import { groupByItemType } from './GroupByItem'

export const getUnpaidBillItems = (items = []) =>
  items.filter(
    item =>
      item?.status?.toLowerCase() === 'unpaid' &&
      !(
        item?.selected_category === 'medication-codes' &&
        item?.internal_pharmacy === false
      )
  )

export const isApprovalPendingItem = item =>
  (item?.approval_status === 'pending' ||
    item?.approval_status === 'rejected') &&
  item?.item_category === 'insurance' &&
  item?.is_approval

export const getBillTabKey = item =>
  item?.selected_category || item?.item_type

export const isSameBillTab = (item, groupKey, unitType) => {
  if (getBillTabKey(item) !== groupKey) return false
  return unitType === 'cash'
    ? item?.item_category === 'cash'
    : item?.item_category !== 'cash'
}

export const mergeFormItems = (items = [], formItems = []) =>
  items.map(item => {
    const editedItem = formItems.find(
      formItem =>
        formItem?.item_id === item?.item_id &&
        formItem?.item_category === item?.item_category
    )
    return editedItem ? { ...item, ...editedItem } : item
  })

export const getOrderedBillItems = (items = []) => {
  const groupedItems = groupByItemType(getUnpaidBillItems(items))
  const orderedItems = []

  Object.keys(groupedItems).forEach(groupKey => {
    const groupItems = groupedItems[groupKey]
    orderedItems.push(
      ...groupItems.filter(item => item?.item_category === 'cash')
    )
    orderedItems.push(
      ...groupItems.filter(item => item?.item_category !== 'cash')
    )
  })

  return orderedItems
}

export const getUnitSelectionState = (items = [], resolveChecked) => {
  const toggleableItems = items.filter(item => !isApprovalPendingItem(item))
  if (!toggleableItems.length) return 'none'

  const checkedCount = toggleableItems.filter(resolveChecked).length
  if (checkedCount === 0) return 'none'
  if (checkedCount === toggleableItems.length) return 'all'
  return 'some'
}

export const groupBillUnits = (items = []) => {
  const groupedItems = groupByItemType(getUnpaidBillItems(items))
  const units = []

  Object.keys(groupedItems).forEach((groupKey, tabIndex) => {
    const groupItems = groupedItems[groupKey]
    const cashItems = groupItems.filter(item => item?.item_category === 'cash')
    const insuranceItems = groupItems.filter(
      item => item?.item_category !== 'cash'
    )

    if (cashItems.length) {
      units.push({ tabIndex, groupKey, unitType: 'cash', items: cashItems })
    }
    if (insuranceItems.length) {
      units.push({
        tabIndex,
        groupKey,
        unitType: 'insurance',
        items: insuranceItems
      })
    }
  })

  return units
}

export const buildPayableUnits = (units = [], items = [], resolveChecked) =>
  units
    .map(unit => ({
      ...unit,
      items: items
        .filter(item => isSameBillTab(item, unit.groupKey, unit.unitType))
        .map(item => ({ ...item, checked: resolveChecked(item) }))
    }))
    .filter(unit => unit.items.some(item => item?.checked))
